import { EMPLOYEES, MANAGER } from "../../config/roles";
import { MC_DEVICE_TYPE, MC_SOFTWARE_TYPE } from "config/const";
import {
  AcUnitOutlined,
  CycloneOutlined,
  DoorSlidingOutlined,
  ElectricBoltOutlined,
  ElevatorOutlined,
  FlashOnOutlined,
  LensBlurOutlined,
  LocalFireDepartmentOutlined,
  OilBarrelOutlined,
  PrecisionManufacturingOutlined,
  SolarPowerOutlined,
  ThermostatAutoOutlined,
  TireRepairOutlined,
  ToggleOnOutlined,
  WaterDropOutlined,
  WbIncandescentOutlined
} from "@mui/icons-material";

export const endpointName = "servicesCall";

export const PMT_TYPE_ID = {
  PAY: 1,
  NOT_PAY: 2,
  SERVICE: 3,
};

export const PMT_TYPE = [
  { id: PMT_TYPE_ID.PAY, name: "PAY" },
  { id: PMT_TYPE_ID.NOT_PAY, name: "NOT_PAY" },
  { id: PMT_TYPE_ID.SERVICE, name: "SERVICE" },
];

export const ST_TYPE_ID = {
  OPEN: 1,
  CLOSE: 2,
  WAITING: 3,
};

export const ST_TYPE = [
  { id: ST_TYPE_ID.OPEN, name: "OPEN" },
  { id: ST_TYPE_ID.CLOSE, name: "CLOSE" },
  { id: ST_TYPE_ID.WAITING, name: "WAITING" },
];

export const COLUMNS_LIST = [
  { name: "clientCallId", role: EMPLOYEES, title: "CLIENT_CALLI_D" },
  { name: "name", role: EMPLOYEES, title: "CONTACT_NAME" },
  { name: "company", role: EMPLOYEES, title: "COMPANY" },
  { name: "addr", role: EMPLOYEES, title: "ADDR" },
  { name: "tel", role: EMPLOYEES, title: "TEL" },
  { name: "notes", role: EMPLOYEES, title: "NOTES" },
  { name: "workDt", role: EMPLOYEES, title: "WORK_DT" },
  { name: "created", role: EMPLOYEES, title: "CREATED" },
  { name: "providers", role: EMPLOYEES, title: "PROVIDERS" },
  { name: "contentWithItems", role: EMPLOYEES, title: "CONTENT_WITH_ITEMS" },
  { name: "price", role: MANAGER, title: "PRICE" },
];

export const DAYS_OF_WEEK = {
  SUN: 1,
  MON: 2,
  TUE: 3,
  WED: 4,
  THU: 5,
  FRI: 6,
  SAT: 7
}

export const HIDE_BUTTON_POWER = [
  MC_SOFTWARE_TYPE.B1_7,
  MC_SOFTWARE_TYPE.B2_0,
  MC_SOFTWARE_TYPE.B2_1,

]

export const getIconByDevice = (deviceType) => {
  if (deviceType === MC_DEVICE_TYPE?.AIR_CONDITIONER)
    return <AcUnitOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.LIGHTING)
    return <WbIncandescentOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.WATER_PUMP)
    return <CycloneOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.BOILER)
    return <OilBarrelOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.GENERATOR)
    return <ElectricBoltOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.COMPRESSOR)
    return <TireRepairOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.ELEVATOR)
    return <ElevatorOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.REFRIGERATION)
    return <AcUnitOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.RELAY)
    return <ToggleOnOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.HVAC)
    return <ThermostatAutoOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.GATE)
    return <DoorSlidingOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.SOLAR)
    return <SolarPowerOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.FIRE_SYSTEM)
    return <LocalFireDepartmentOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.IRRIGATION)
    return <WaterDropOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.MACHINE)
    return <PrecisionManufacturingOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.STEAM_SYSTEM)
    return <LensBlurOutlined fontSize="small" sx={{ color: "primary.main" }} />
  if (deviceType === MC_DEVICE_TYPE?.ELECTRICAL_ROOM)
    return <FlashOnOutlined fontSize="small" sx={{ color: "primary.main" }} />
}